export default __webpack_public_path__ + "static/media/SIFA_FR_INTRO.726fb04f.mp3";